<template>
  <div class="article-card pa-1 ma-n1" v-ripple>
    <router-link v-if="img" :to="to">
      <img
        :src="img + '?resize=1&w=270'"
        :alt="title"
        :title="title"
        loading="lazy"
      />
    </router-link>
    <router-link
      :to="to"
      class="d-block text-decoration-none white--text font-weight-regular pt-1 pb-2 article-card-title"
    >
      <div class="pl-1">
        {{ title }}
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
    },
    to: {
      type: String,
    },
  },
};
</script>

<style>
.article-card {
  background-color: transparent;
  max-width: 270px;
  position: relative;
  transition: all 0.1s linear;
}

.article-card:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.article-card-fluid {
  max-width: initial;
}

.article-card img {
  aspect-ratio: 270 / 179;
  object-fit: cover;
  -o-object-fit: cover;
  width: 100%;
}

.article-card-title {
  font-size: 18px;
  line-height: 24px;
}

.article-card img,
.article-card-title,
.article-card-category {
  transition: all 0.1s linear;
}

@media screen and (max-width: 1264px) {
  .article-card-title {
    font-size: 14px;
  }
}

.article-card:hover img {
  opacity: 0.8;
}

.article-card:hover .article-card-title {
  color: var(--v-secondary-lighten2) !important;
}

.article-card-category-wrap-small {
  position: absolute;
  top: 4px;
  left: 4px;
}
</style>
